// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SplitDownArrowIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 24 16">
    <path d="M9.33 16h5.34v-2.67H9.33zM0 0v2.67h24V0zm4 9.33h16V6.67H4z" />
  </svg>,
  "SplitDownArrow",
);
export default SplitDownArrowIcon;
